import { Button } from '@/shared/Button';
import { useContext } from 'react';
import Image from 'next/image';
import spinnerIcon from '@/assets/vectors/icons/spinner.svg';
import { ExportContext } from '../ExportCompound.context';

export const DownloadGraphics = (): React.ReactNode => {
  const { handleDownloadGraphics, data } = useContext(ExportContext);

  return (
    <div className={`mt-6 ${data.graphicsMapToggle ? 'hidden' : 'visible'}`}>
      <Button onClick={handleDownloadGraphics} disabled={data.isDownloadingImage}>
        {data.isDownloadingImage && (
          <Image
            src={spinnerIcon}
            alt="spinner icon"
            height={12}
            width={12}
            className="mr-5 animate-spin"
          />
        )}
        Download image
      </Button>
    </div>
  );
};
